module.exports = __webpack_public_path__ + "img/12.10.pH.19944980.png";